import { render, staticRenderFns } from "./dangerWasterLicenseFiles.vue?vue&type=template&id=be169756&scoped=true&"
import script from "./dangerWasterLicenseFiles.vue?vue&type=script&lang=js&"
export * from "./dangerWasterLicenseFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.10.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be169756",
  null
  
)

export default component.exports